import i18n from "@/i18n.ts";
import * as yup from "yup";

export const buildWorkflowEditDetailsSchema = () =>
  yup.object({
    title: yup.string().required(i18n.t("errors:field_required")),
    description: yup.string().nullable().defined(),
    folder_id: yup.number().required(i18n.t("errors:field_required")),
  });
